{
  "utcClock": "Current time (UTC)",
  "clockSkew": "Device clock",
  "clockSkewMeasuring": "Measuring",
  "clockSkewOffline": "No connection",
  "clockSkewOfflineDeviceClock": "No connection, uncorrected",
  "remainingIdle": "T− --:--",
  "remainingLabel": "Time remaining",
  "typeAttack": "attack",
  "typeDefense": "defense",
  "typeUnset": "no type",
  "summaryEmpty": "No ops",
  "langSwitch": "Display language",
  "remainingAllOpen": "All opened",
  "bandAttackCount": "Rallies: {n}",
  "bandAttackNext": "Rallies: {n}, next {roster} {offset}",
  "bandDefenseCount": "Enemy rallies: {n}",
  "bandNeedCode": "Admin code needed",
  "bandOtherTab": "In use in another tab"
}
